import { forwardRef, Ref, type SVGProps } from 'react';

const SvgSoil = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <path
      fill="#033532"
      d="m15.894 13.074 1.132 6.546H2l4.604-7.566 2.866-.758-.824-4.098L5.634 6.13 4.136 4.034 3.828.5 8.31 2.102l1.984 4.482 2.098-2.012 2.818-.564 2.896 1.126-3.662 3.382h-3.662l.44 2.314.08-.02z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSoil);
export default ForwardRef;
